import { render } from "./MenuHealthConfiguration.vue?vue&type=template&id=2770f1d4&scoped=true"
import script from "./MenuHealthConfiguration.vue?vue&type=script&lang=js"
export * from "./MenuHealthConfiguration.vue?vue&type=script&lang=js"

import "./MenuHealthConfiguration.vue?vue&type=style&index=0&id=2770f1d4&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2770f1d4"]])

export default __exports__